import React from 'react';
import QuickToggles from '../common/QuickToggles';

// Kept outside the record's scroll region, alongside the customer action bar.
export default function ContractStatusControls({ contract, options = [], loading, onToggle, saving }) {
  if (!contract || loading || !options.length) return null;
  return <section id="contract-status" className="pipeline-status-controls" aria-label="Status controls" tabIndex={-1}>
    <span className="pipeline-status-caption">Status controls</span>
    <QuickToggles data={contract} toggleOptions={options} onToggle={onToggle} toggling={saving}/>
  </section>;
}
